var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-row',{staticClass:"mb-2",attrs:{"type":"flex","align":"top","justify":"center"}},[_c('el-col',{staticClass:"text--center mr-2",staticStyle:{"max-width":"24px"}},[_vm._t("icon")],2),_c('el-col',[_vm._t("title")],2)],1),_c('el-row',[_c('el-col',[_c('div',{staticClass:"text-size--body-small"},[_vm._t("description")],2)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }